// Rails returns errors for each form attr in an array but
//   we need a string to display under the form input
// Return a new object with it's values joined.
const formatErrorResponse = (error, generalErrors = {}) => error.response.json().then((res) => {
  const errors = res.errors || {};
  return Object.assign(
    generalErrors,
    ...Object.keys(errors)
      .map(k => ({ [k]: errors[k].join(', ') }))
  );
});

const reportError = (error, toHoneybadger) => {
  console.error('Error:', error);
  if (toHoneybadger) Honeybadger.notify(error);
  return error;
};

const handleError = (error, cb) => {
  if (cb) cb(error);
  reportError(error, !!error.fromApi);
};

// Use within catch for form submit requests
const handleSubmitError = (error, formActions, msg) => {
  handleError(error);
  if (error.apiError) {
    formatErrorResponse(error, { submitFailedMsg: msg })
      .then(parsedErrors => formActions.setErrors(parsedErrors));
  }
  formActions.setSubmitting(false);
};

export { handleError, handleSubmitError };



// WEBPACK FOOTER //
// ./app/javascript/app/utils/errors.js